// import React, { useEffect, useState } from "react";
// import { Typography, Button, Row, Col, Select, Spin } from 'antd';
// import { PlusOutlined } from '@ant-design/icons';
// import SidebarLayout from "./SidebarLayout";
// import { Table } from 'antd'
// import _BankAdminService from "../../modules/BankAdminService";

// const { Option } = Select;
// const { Title } = Typography;

// const LiveAccountBalances = () => {
//    const bankadminIdRaw = localStorage.getItem("Id");
//   const firmId = bankadminIdRaw ? parseInt(bankadminIdRaw) : null;
//   const [liveAccountBalanceData, setLiveAccountBalanceData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   useEffect(()=>{
//     getFirmAdminDataByFirmAdminId();
//   },[]);

//   const getFirmAdminDataByFirmAdminId = async () => {
//         try {
//             setLoading(true);
//             const res = await _BankAdminService.getFirmAdminDataByFirmAdminId(firmId);
//             if (res?.data?.IsSuccess && res.data.Obj) {
//                 setLoading(false);
//                setLiveAccountBalanceData(res.data.Obj);
//             } else {
//                 setLoading(false);
//             }
//         } catch (error) {
//             setLoading(false);
//             console.error("Error fetching banker information:", error);
//         }
//     };

//   const columns = [
//     {
//       title: 'Approved Borrower Name',
//       dataIndex: 'BorrowerName',
//       key: 'BorrowerName',
//     },
//     {
//       title: 'Account Number',
//       dataIndex: 'AccountNumber',
//       key: 'AccountNumber',
//     },
//     {
//       title: 'Approved Loan Amount ($)',
//       dataIndex: 'ApprovedLoanAmount',
//       key: 'ApprovedLoanAmount',
//      render: (value) => `${Number(value).toLocaleString()}`,
//     },
//     {
//       title: 'Current Outstanding Balance ($)',
//       dataIndex: 'OutstandingBalanace',
//       key: 'OutstandingBalanace',
//      render: (value) => `${Number(value).toLocaleString()}`,
//     },
//   ];

//   return (
//      <Spin spinning={loading}>
//     <SidebarLayout>
//       <Row justify="space-between" align="middle" className="mb20">
//         <Col>
//           <Title level={3} style={{ marginBottom: 0 }}>Live Account Balances</Title>
//         </Col>

//       </Row>
//       {/* <Row justify="space-between" align="middle" className="mb20">       
//         <Col>
//           <label style={{ fontWeight: "bold" }}>Choose Option: </label>
//           <Select
//             style={{ width: 200 }}
//             placeholder="Select an option"
//             onChange={(value) => console.log("Selected:", value)}
//           >
//             <Option value="1">Option 1</Option>
//             <Option value="2">Option 2</Option>
//             <Option value="3">Option 3</Option>
//           </Select>
//         </Col>
//         <Col>
//           <Button type="primary">
//             Add
//           </Button>
//         </Col>
//       </Row> */}

//       <Table dataSource={liveAccountBalanceData} columns={columns} pagination={false} />
//     </SidebarLayout>
//     </Spin>
//   )
// }

// export default LiveAccountBalances;


import React, { useEffect, useState } from "react";
import { Typography, Button, Row, Col, Select, Spin, Table, InputNumber, Tooltip, message, Modal } from 'antd';
import moment from "moment";
import SidebarLayout from "./SidebarLayout";
import _BankAdminService from "../../modules/BankAdminService";
import FormItemSelect from "../../components/FormItems/FormItemSelect";
import './LiveAccountBalancesForBanker.scss';
import { SENIOR_PRIVATE_BANKER_ROLE_ID } from "../../constants/DataConstants";
import _NewapplicationService from "../../modules/NewapplicationService";
import { SaveOutlined, CloseOutlined, EditOutlined, EyeOutlined, DownloadOutlined } from "@ant-design/icons";
import ExcelJS from "exceljs";
import { COMMON_ERROR_MSG } from "../../constants/constants";


const { Option } = Select;
const { Title } = Typography;

const LiveAccountBalancesForBanker = () => {
  const loginEmail = localStorage.getItem("loginEmail");
  //const bankAdminId = localStorage.getItem("BankAdminId");
  const BankerId = localStorage.getItem("BankerId");
  const roleId = Number(localStorage.getItem("RoleId") ?? 0);
  const [selectedSponsor, setSelectedSponsor] = useState(null);
  const [firmList, setFirmList] = useState([]);
  const [selectedFirm, setSelectedFirm] = useState(null);
  const [loanProgramTypeList, setLoanProgramTypeList] = useState([]);
  const [selectedLoanProgramType, setSelectedLoanProgramType] = useState(null);
  const [liveAccountBalanceData, setLiveAccountBalanceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loanProgrameType, setLoanProgrameType] = useState(null);
  const [submittedByName, setSubmittedByName] = useState(null);
  const [submittedDate, setSubmittedDate] = useState(null);

  const bankadminIdRaw = localStorage.getItem("BankAdminId");
  const BankAdminId = bankadminIdRaw ? parseInt(bankadminIdRaw) : null;
  const [BankAdminID, setBankAdminID] = useState(BankAdminId);

  const bankerRoleId = Number(localStorage.getItem("RoleId") ?? 0);
  const isBanker = bankerRoleId === SENIOR_PRIVATE_BANKER_ROLE_ID;

  const getTableEmptyText = () => {
    return <div className="table-empty-message">No Data.</div>;
  };

  useEffect(() => {
    if (BankAdminID && BankerId) {
      getFirmList(BankerId, BankAdminID);
    }
  }, [BankAdminID, BankerId]);
  useEffect(() => {
    const handleBankAdminIdChange = (e) => {
      const newId = e.detail.newId;
      setBankAdminID(newId);
    };

    window.addEventListener("BankAdminIdChanged", handleBankAdminIdChange);

    return () => {
      window.removeEventListener("BankAdminIdChanged", handleBankAdminIdChange);
    };
  }, []);

  // useEffect(() => {
  //   getSponsorList(BankerId, BankAdminID);
  // }, []);

  const formatCurrency = (value) => {
    if (value === null || value === undefined || value === "")
      return "-";

    const cleanValue =
      typeof value === "string"
        ? value.replace(/[^0-9.-]+/g, "")
        : value;

    const num = Number(cleanValue);

    return !isNaN(num)
      ? `$${num.toLocaleString("en-US", { minimumFractionDigits: 2 })}`
      : "-";
  };

  // Fetch firm list (Choose Credit Facility)
  const getFirmList = async (BankerId, bankAdminId) => {
    try {
      setLoading(true);
      const res = await _BankAdminService.getFirmDropdownListByBankerIdV1(BankerId, roleId, isBanker);

      if (res?.data?.IsSuccess && res.data.Obj) {
        setFirmList(res.data.Obj);
        if (res.data.Obj.length > 0) {
          // auto-select first firm and cascade into its loan programe types
          const firstFirm = res.data.Obj[0];
          setSelectedFirm(firstFirm.Id);
          await getLoanProgramTypeList(firstFirm.Id);
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching firm list:", error);
    }
  };

  // Fetch loan programe type list for the selected firm (Choose Loan Programe Type)
  const getLoanProgramTypeList = async (firmId, autoSelect = true) => {
    try {
      setLoading(true);
      const res = await _BankAdminService.getLoanProgrameTypeListByFirmId(firmId, { bankerId: BankerId, roleId, isBanker });

      if (res?.data?.IsSuccess && res.data.Obj) {
        setLoanProgramTypeList(res.data.Obj);
        if (autoSelect && res.data.Obj.length > 0) {
          // auto-select first credit facility and fetch its balances. Each entry is now keyed by its
          // own unique SponserId (a firm can have multiple facilities sharing the same
          // LoanProgrameTypeId, differentiated only by Credit Facility Name), so the Select is bound
          // to SponserId while LoanProgrameTypeId is kept separately for type-branching below.
          const firstType = res.data.Obj[0];
          setSelectedLoanProgramType(firstType.SponserId);
          setLoanProgrameType(firstType.LoanProgrameTypeId);
          await getFirmAdminDataForFacility(firmId, firstType.LoanProgrameTypeId, firstType.SponserId);
        } else {
          setSelectedLoanProgramType(null);
          setSelectedSponsor(null);
          setLoanProgrameType(null);
          setLiveAccountBalanceData([]);
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching loan programe type list:", error);
    }
  };

  // Fetch balances for the exact selected Sponser record (SponserId), falling back to the old
  // Firm+LoanProgrameType guess only if no SponserId is available (shouldn't normally happen now).
  const getFirmAdminDataForFacility = async (firmId, loanProgramTypeId, sponserId) => {
    try {
      setLoading(true);
      const res = await _BankAdminService.getFirmAdminDataByFirmAndLoanProgrameType(firmId, loanProgramTypeId, sponserId);
      if (res?.data?.IsSuccess && res.data.Obj) {
        setLiveAccountBalanceData(res.data.Obj);
        setSelectedSponsor(res.data.Obj[0]?.SponserId ?? null);

        const rowsWithSubmission = res.data.Obj.filter(
          (row) => row.SubmittedByName && row.SubmittedDate
        );
        if (rowsWithSubmission.length > 0) {
          const latest = rowsWithSubmission.reduce((a, b) =>
            new Date(a.SubmittedDate) > new Date(b.SubmittedDate) ? a : b
          );
          setSubmittedByName(latest.SubmittedByName);
          setSubmittedDate(latest.SubmittedDate);
        } else {
          setSubmittedByName(null);
          setSubmittedDate(null);
        }
      } else {
        setLiveAccountBalanceData([]);
        setSubmittedByName(null);
        setSubmittedDate(null);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching firm admin data:", error);
    }
  };

  const handleFirmChange = (value) => {
    setSelectedFirm(value);
    setSelectedLoanProgramType(null);
    setLoanProgramTypeList([]);
    setLiveAccountBalanceData([]);
    setSelectedSponsor(null);
    getLoanProgramTypeList(value, false);
  };

  const handleLoanProgramTypeChange = (value) => {
    // `value` is the selected dropdown entry's SponserId (unique per row); look up its
    // LoanProgrameTypeId from the list to keep type-branching (isSubscriptionLine/isCorporateLoan) working.
    const matchedFacility = loanProgramTypeList.find((type) => type.SponserId === value);
    setSelectedLoanProgramType(value);
    setLoanProgrameType(matchedFacility?.LoanProgrameTypeId ?? null);
    getFirmAdminDataForFacility(selectedFirm, matchedFacility?.LoanProgrameTypeId, value);
  };

  // Export for Subscription Line of Credit (type 2) / Corporate Loan (type 4) facilities --
  // mirrors the on-screen subscriptionLineColumns/corporateLoanColumns column sets.
  const exportFacilityLevelExcel = async (programData, balances) => {
    const HEADER_FILL = "FF2F6169";
    const SHADED_FILL = "FFD9D9D9";
    const THIN_BORDER = { style: "thin", color: { argb: "FF808080" } };
    const CELL_BORDER = {
      top: THIN_BORDER,
      left: THIN_BORDER,
      bottom: THIN_BORDER,
      right: THIN_BORDER,
    };

    const headerLabels = isSubscriptionLine
      ? ["Borrower Fund", "Institution", "Total Commitment", "Borrowing Base", "Outstanding", "Availability", "Advance Rate"]
      : ["Portfolio Company", "Institution", "Loan Structure", "Total Facility Size $", "Current Outstanding Balance", "Availability", "Maturity Date"];

    const rowValuesFor = (item) =>
      isSubscriptionLine
        ? [
            item.BorrowerFund || "-",
            item.Institution || "-",
            item.TotalCommitment ? `$${Number(item.TotalCommitment).toLocaleString("en-US")}` : "-",
            item.BorrowingBase ? `$${Number(item.BorrowingBase).toLocaleString("en-US")}` : "-",
            formatCurrency(item.OutstandingBalanace),
            item.Availability ? `$${Number(item.Availability).toLocaleString("en-US")}` : "-",
            item.AdvanceRate ? `${item.AdvanceRate}%` : "-",
          ]
        : [
            item.PortfolioCompany || "-",
            item.Institution || "-",
            item.LoanStructure || "-",
            item.OriginalFacilitySize ? `$${Number(item.OriginalFacilitySize).toLocaleString("en-US")}` : "-",
            formatCurrency(item.OutstandingBalanace),
            item.Availability ? `$${Number(item.Availability).toLocaleString("en-US")}` : "-",
            item.MaturityDate ? moment(item.MaturityDate).format("MM/DD/YYYY") : "-",
          ];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Account Balances");

    worksheet.columns = headerLabels.map(() => ({ width: 20 }));

    worksheet.mergeCells(1, 1, 1, headerLabels.length);
    const titleCell = worksheet.getCell("A1");
    titleCell.value = isSubscriptionLine ? "Account Balances — Subscription Line of Credit" : "Account Balances — Corporate Loan";
    titleCell.font = { bold: true, size: 13 };
    titleCell.alignment = { vertical: "middle" };
    worksheet.getRow(1).height = 22;

    worksheet.getCell("A2").value = "Firm";
    worksheet.getCell("B2").value = programData.Name || "-";
    worksheet.getCell("A3").value = "Institution";
    worksheet.getCell("B3").value = programData.Institution || "-";
    worksheet.getCell("A4").value = "As-of Date";
    worksheet.getCell("B4").value = moment().format("MM/DD/YYYY");
    ["A2", "A3", "A4"].forEach((addr) => {
      worksheet.getCell(addr).font = { bold: true };
    });
    ["B2", "B3", "B4"].forEach((addr) => {
      worksheet.getCell(addr).fill = { type: "pattern", pattern: "solid", fgColor: { argb: SHADED_FILL } };
    });

    const headerRowIndex = 6;
    const headerRow = worksheet.getRow(headerRowIndex);
    headerLabels.forEach((label, idx) => {
      const cell = headerRow.getCell(idx + 1);
      cell.value = label;
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: HEADER_FILL } };
      cell.alignment = { vertical: "middle", horizontal: "left" };
      cell.border = CELL_BORDER;
    });
    headerRow.height = 20;
    headerRow.commit();

    let currentRowIndex = headerRowIndex + 1;
    balances.forEach((item) => {
      const row = worksheet.getRow(currentRowIndex);
      rowValuesFor(item).forEach((val, idx) => {
        const cell = row.getCell(idx + 1);
        cell.value = val;
        cell.border = CELL_BORDER;
        cell.alignment = { horizontal: "left" };
      });
      row.commit();
      currentRowIndex += 1;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "Levridge_Account_Balances_Export.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  // Export live account balances (by sponsorId) to .xlsx
  const handleDownloadExcel = async () => {
    if (!selectedSponsor) {
      message.warning("Please select a loan program first.");
      return;
    }

    try {
      setLoading(true);
      const res = await _NewapplicationService.getApplicantLiveBalanceBySponserId(selectedSponsor);

      if (!res?.data?.IsSuccess || !res.data.Obj) {
        message.error(res?.data?.Message || COMMON_ERROR_MSG);
        return;
      }

      const programData = res.data.Obj;
      const balances = programData.listApplicantLiveBalances || [];

      if (isSubscriptionLine || isCorporateLoan) {
        await exportFacilityLevelExcel(programData, balances);
        return;
      }

      const HEADER_FILL = "FF2F6169";
      const SHADED_FILL = "FFD9D9D9";
      const TOTAL_FILL = "FFEDEDED";
      const THIN_BORDER = { style: "thin", color: { argb: "FF808080" } };
      const CELL_BORDER = {
        top: THIN_BORDER,
        left: THIN_BORDER,
        bottom: THIN_BORDER,
        right: THIN_BORDER,
      };

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Account Balances");

      worksheet.columns = [
        { width: 24 },
        { width: 20 },
        { width: 16 },
        { width: 12 },
        { width: 18 },
        { width: 14 },
        { width: 14 },
        { width: 22 },
      ];

      // Title
      worksheet.mergeCells("A1:H1");
      const titleCell = worksheet.getCell("A1");
      titleCell.value = "Account Balances — Loan Program";
      titleCell.font = { bold: true, size: 13 };
      titleCell.alignment = { vertical: "middle" };
      worksheet.getRow(1).height = 22;

      // Loan Program / Institution / Program Size / As-of Date summary block
      worksheet.mergeCells("B2:C2");
      worksheet.mergeCells("E2:H2");
      worksheet.mergeCells("B3:C3");
      worksheet.mergeCells("E3:H3");

      worksheet.getCell("A2").value = "Loan Program";
      worksheet.getCell("D2").value = "Institution";
      worksheet.getCell("A3").value = "Program Size";
      worksheet.getCell("D3").value = "As-of Date";
      ["A2", "D2", "A3", "D3"].forEach((addr) => {
        worksheet.getCell(addr).font = { bold: true };
      });

      worksheet.getCell("B2").value = programData.Name || "-";
      worksheet.getCell("E2").value = programData.Institution || "-";
      worksheet.getCell("B3").value = formatCurrency(programData.TotalProgrameSize);
      worksheet.getCell("E3").value = moment().format("MM/DD/YYYY");
      ["B2", "E2", "B3", "E3"].forEach((addr) => {
        worksheet.getCell(addr).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: SHADED_FILL },
        };
      });

      worksheet.getRow(2).height = 18;
      worksheet.getRow(3).height = 18;

      // Table header (row 5, leaving row 4 as a spacer)
      const headerRowIndex = 5;
      const headerLabels = [
        "Approved Client Name",
        "Facility Reference",
        "Application Id",
        "Approved Loan Amount",
        "Current Outstanding Balance",
        "As-of Date",
        "Entered By",
        "Entered On",
      ];
      const headerRow = worksheet.getRow(headerRowIndex);
      headerLabels.forEach((label, idx) => {
        const cell = headerRow.getCell(idx + 1);
        cell.value = label;
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: HEADER_FILL } };
        cell.alignment = { vertical: "middle", horizontal: "left" };
        cell.border = CELL_BORDER;
      });
      headerRow.height = 20;
      headerRow.commit();

      // Data rows
      let totalBalance = 0;
      let currentRowIndex = headerRowIndex + 1;

      balances.forEach((item) => {
        totalBalance += Number(item.OutstandingBalanace) || 0;
        const rowDate = item.UpdatedDate || item.CreatedDate;

        const rowValues = [
          item.ApplicantName || "-",
          item.AccountNumber || "-",
          item.ApplicationId || "-",
          item.ApprovedLoanAmount ? `$${Number(item.ApprovedLoanAmount).toLocaleString("en-US")}` : "-",
          formatCurrency(item.OutstandingBalanace) || "-",
          rowDate ? moment(rowDate).format("MM/DD/YYYY") : "-",
          item.EnteredBy || "-",
          item.CreatedDate ? moment(item.CreatedDate).format("MM/DD/YYYY hh:mm:ss A") : "-",
        ];

        const row = worksheet.getRow(currentRowIndex);
        rowValues.forEach((val, idx) => {
          const cell = row.getCell(idx + 1);
          cell.value = val;
          cell.border = CELL_BORDER;
          cell.alignment = { horizontal: "left" };
        });
        row.commit();
        currentRowIndex += 1;
      });

      // Total row
      const totalRow = worksheet.getRow(currentRowIndex);
      const totalValues = ["Total", "", "", "", formatCurrency(totalBalance), "", "", ""];
      totalValues.forEach((val, idx) => {
        const cell = totalRow.getCell(idx + 1);
        cell.value = val;
        cell.border = CELL_BORDER;
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: TOTAL_FILL } };
        cell.font = { bold: true };
      });
      totalRow.commit();

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Levridge_Account_Balances_Export.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting live account balances:", error);
      message.error(COMMON_ERROR_MSG);
    } finally {
      setLoading(false);
    }
  };


  const columns = [
    {
      title: 'Approved Client Name',
      dataIndex: 'BorrowerName',
      key: 'BorrowerName',
    },
    {
      title: 'Facility Reference',
      dataIndex: 'AccountNumber',
      key: 'AccountNumber',
    },
    {
      title: 'Approved Loan Amount',
      dataIndex: 'ApprovedLoanAmount',
      key: 'ApprovedLoanAmount',
      render: (value) =>
        value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    {
      title: 'Current Outstanding Balance',
      dataIndex: 'OutstandingBalanace',
      key: 'OutstandingBalanace',
      render: (value) =>
        value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
  ];

  // Subscription Line of Credit (LoanProgrameTypeId 2) -- one row per SponserFund, facility-level fields.
  const subscriptionLineColumns = [
    { title: 'Borrower Fund', dataIndex: 'BorrowerFund', key: 'BorrowerFund', render: (value) => value || "-" },
    { title: 'Facility', dataIndex: 'Institution', key: 'Institution', render: (value) => value || "-" },
    {
      title: 'Total Commitment', dataIndex: 'TotalCommitment', key: 'TotalCommitment',
      render: (value) => value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    {
      title: 'Borrowing Base', dataIndex: 'BorrowingBase', key: 'BorrowingBase',
      render: (value) => value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    {
      title: 'Outstanding', dataIndex: 'OutstandingBalanace', key: 'OutstandingBalanace',
      render: (value) => value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    {
      title: 'Availability', dataIndex: 'Availability', key: 'Availability',
      render: (value) => value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    { title: 'Advance Rate', dataIndex: 'AdvanceRate', key: 'AdvanceRate', render: (value) => value ? `${value}%` : "-" },
  ];

  // Corporate Loan (LoanProgrameTypeId 4) -- single facility-level row.
  const corporateLoanColumns = [
    { title: 'Portfolio Company', dataIndex: 'PortfolioCompany', key: 'PortfolioCompany', render: (value) => value || "-" },
    { title: 'Facility', dataIndex: 'Institution', key: 'Institution', render: (value) => value || "-" },
    { title: 'Loan Structure', dataIndex: 'LoanStructure', key: 'LoanStructure', render: (value) => value || "-" },
    {
      title: 'Total Facility Size $', dataIndex: 'TotalFacilitySize', key: 'TotalFacilitySize',
      render: (value) => value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    {
      title: 'Current Outstanding Balance', dataIndex: 'OutstandingBalanace', key: 'OutstandingBalanace',
      render: (value) => value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    {
      title: 'Availability', dataIndex: 'Availability', key: 'Availability',
      render: (value) => value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    {
      title: 'Maturity Date', dataIndex: 'MaturityDate', key: 'MaturityDate',
      render: (value) => value ? moment(value).format("MM/DD/YYYY") : "-",
    },
  ];

  const isSubscriptionLine = Number(loanProgrameType) === 2;
  const isCorporateLoan = Number(loanProgrameType) === 4;
  const activeColumns = isSubscriptionLine ? subscriptionLineColumns : isCorporateLoan ? corporateLoanColumns : columns;
  const activeRowKey = isSubscriptionLine || isCorporateLoan ? "Id" : "AccountNumber";

  return (
    <Spin spinning={loading}>
      <SidebarLayout>
        <div className="live-account-balances-container">
          <Title level={3} className="page-title">
          Account Balances
          </Title>
          <Title level={5} className="page-sub-title">
          View balances for approved borrowers under the selected credit facilities.
          </Title>

          <div className="card-section choose-loan-program-section inputDisabledBlackColor">
            <label className="choose-loan-program-label">Select Firm : </label>
            <Select
              placeholder="Select Firm"
              value={selectedFirm}
              onChange={handleFirmChange}
              popupClassName="loan-program-dropdown"
            >
              {firmList.map((firm) => (
                <Option key={firm.Id} value={firm.Id}>
                  {firm.FirmName}
                </Option>
              ))}
            </Select>

            <label className="choose-loan-program-label">Select Credit Facility : </label>
            <Select
              placeholder="Select Credit Facility Type"
              value={selectedLoanProgramType}
              onChange={handleLoanProgramTypeChange}
              popupClassName="loan-program-dropdown"
            >
              {loanProgramTypeList.map((type) => (
                <Option key={type.SponserId} value={type.SponserId}>
                  {type.Name}
                </Option>
              ))}
            </Select>

            {submittedByName && submittedDate && (
              <div style={{ marginLeft: "auto", display: "flex", flexDirection: "column", gap: 4, color: "#f4f4f5b2" }}>
                <span>
                  <strong style={{ color: "#f4f4f5" }}>Submitted By :</strong> {submittedByName}
                </span>
                <span>
                  <strong style={{ color: "#f4f4f5" }}>Date &amp; Time :</strong>{" "}
                  {moment.utc(submittedDate).local().format("MM/DD/YYYY hh:mm A")}
                </span>
              </div>
            )}

            {/* <FormItemSelect
              label=""
              name="sponsorSelect"
              placeholder="Select Sponsor"
              value={selectedSponsor}
              onChange={handleSponsorChange}
              options={sponsorList.map((sponsor) => ({
                label: sponsor.SponserName,
                value: sponsor.SponserId,
              }))}
            /> */}
          </div>

          {/* Account Balance Table */}
          <Table
            dataSource={liveAccountBalanceData}
            columns={activeColumns}
            rowKey={activeRowKey}
            pagination={false}
            className="transparent-table"
            locale={{ emptyText: getTableEmptyText() }}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            onClick={handleDownloadExcel}
            disabled={!selectedSponsor}
          >
            Export Excel
          </Button>
        </div>
      </SidebarLayout>
    </Spin>
  );
};

export default LiveAccountBalancesForBanker;